import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/ateliers")({
  staticData: { breadcrumb: { label: "sidebar.ateliers" } },
  component: () => <Outlet />,
});
